import axios from 'axios';
import wx from "weixin-js-sdk";

export default {
  install: function (Vue, opt) {
    Vue.prototype.$wx = wx;
    Vue.prototype.$bus = new Vue();
    let u = navigator.userAgent;
    Vue.prototype.$isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    Vue.prototype.$isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    Vue.prototype.$documentHeight = document.documentElement.clientHeight
  }
}
